<div *ngIf="RequestModel && Model && Model.TotalRecords == 0" class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div>

<div class="" *ngIf="RequestModel && Model && Model.TotalRecords > 0">
    <div class="row align-items-center no-gutters pagerow flex-nowrap">
        <div class="col-auto mr-4" *ngIf="Model && Model.TotalRecords > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="Model.TotalRecords" [pageSize]="RequestModel.PageSize" [(page)]="RequestModel.PageNumber" [boundaryLinks]="true" (pageChange)="onPageChange()"></ngb-pagination>
        </div>
        <div class="col-auto" *ngIf="Model && HideTotalPages == false"><span translate>LBL.TOTAL_RECORDS</span>: <B>{{Model.TotalRecords}}</B></div>
    </div>
    <div class="row">
        <div class="col">
            <sk-wave [isRunning]="IsSubmitting"></sk-wave>

            <div  *ngIf="IsSubmitting == false && Model && Model.TotalRecords > 0">
                <div class="grdGrid">

                    <div class="grdRow row pointer no-gutters jobdetails" id="jobdetail-{{row.ComplainId}}" *ngFor="let row of Model.Result; trackBy: TrackResult" tabindex="0" (keyup.enter)="onRowSelected(row)" (click)="onRowSelected(row)" [ngClass]="{'selected': complainService.SelectedJob && row.ComplainId == complainService.SelectedJob.ComplainId }">
                        <div class="col-auto grdCol">
                            <div class="ic-status active" title="{{row.IsEsc ? ('TITLE.TITLE_ESCALATION_LEVEL' | translate) : ('TITLE.TITLE_NOT_ESCALATED' | translate)}}"><span *ngIf="row.CurrEscLevel > 0" class="value"><i class="fas fa-arrow-up"></i>&nbsp;{{row.CurrEscLevel}}</span></div>
                            <div title="{{'TITLE.TITLE_CALL_NO' | translate}}">{{row.DisplayCallNo }} - <span title="{{row.IsGuestCall ? ('TITLE.TITLE_GUEST_JOB' | translate) : ('TITLE.TITLE_STAFF_JOB' | translate)}}">{{row.IsGuestCall ? '(G)': '(S)'}}</span></div>
                        </div>

                        <div class="col-auto grdCol justify-content-center">
                            <div class="text-center statusIcon-Standard status-{{row.CurrentStatus}} border-0" title="{{'TITLE.TITLE_CALLSTATUS_'+row.CurrentStatus | translate}}"></div>
                        </div>

                        <div class="col-auto grdCol" [hidden]="Mode == 1">
                            <div title="{{row.LocationName}}"><i class="fas fa-map-marker-alt"></i>&nbsp;{{row.LocationName}}</div>
                        </div>

                        <div class="col-auto grdCol">
                            <div class="fa-fw" *ngIf="row.NoOfAttachments > 0" title="{{row.NoOfAttachments > 0 ? (('TITLE.TITLE_ATTACHMENTS' | translate) + ' - ' + row.NoOfAttachments) : ('TITLE.TITLE_NO_ATTACHMENTS' | translate)}}"><i class="fas fa-paperclip"></i></div>
                        </div>

                        <div class="col-auto grdCol">
                            <div class="ellipsis" title="{{row.CallDescription}}">{{row.CallDescription}}</div>
                            <div *ngIf="row.AssignedTo > 0" class="ellipsis small" title="{{('TITLE.TITLE_ASSIGNED_STAFF' | translate) + ' - ' + row.AssignToName}}">
                                <i class="fas fa-user"></i>&nbsp;{{row.AssignToName}}
                            </div>
                            <div *ngIf="row.AssignedTo == null" class="text-danger small" title="{{'TITLE.TITLE_UNASSIGNED' | translate}}"><i class="fas fa-user"></i>&nbsp;<span translate>LBL.UNASSIGNED</span></div>
                        </div>

                        <div class="col-auto grdCol">
                            <div *ngIf="row.LastRemarks == null || row.LastRemarks.length == 0">&nbsp;</div>
                            <div class="consoleRemarks ellipsis" *ngIf="row.LastRemarks && row.LastRemarks.length > 0" title="{{row.LastRemarks}}">{{row.LastRemarks}}</div>
                            <div class="small" [ngClass]="row.ReOpenedFromClose ? 'text-danger' : 'text-muted'" title="{{'TITLE.TITLE_REGISTERED_AT' | translate}}"><i class="fa-fw fas fa-lock-open"></i> {{row.RegisteredAt | amDateFormat: DateFormat}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

